<div class="component-box" *ngIf="isSearchVisible">
  <form (ngSubmit)="onSearch()" class="search-form">
    <div class="search-fields">
      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showRegion">
        <mat-label>Region</mat-label>
        <mat-select [(ngModel)]="searchForm.region" name="region" placeholder="Region" (selectionChange)="onRegionChange()">
          <mat-option *ngFor="let region of regions" [value]="region.value">
            {{ region.label }}
          </mat-option>
        </mat-select>
        <button *ngIf="searchForm.region" mat-icon-button matSuffix (click)="searchForm.region = undefined; onRegionChange(); $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showCountry">
        <mat-label>Country</mat-label>
        <mat-select [(ngModel)]="searchForm.countryId" name="countryId" placeholder="Country">
          <mat-option *ngFor="let country of countries$ | async" [value]="country.id">
            {{ country.name }}
          </mat-option>
        </mat-select>
        <button *ngIf="searchForm.countryId" mat-icon-button matSuffix (click)="searchForm.countryId = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showCode">
        <mat-label>Internal ID</mat-label>
        <input matInput [(ngModel)]="searchForm.code" name="code" placeholder="Search by internal ID">
      </mat-form-field>

      <mat-form-field appearance="fill" *ngIf="fieldsConfig.showName">
        <mat-label>Name</mat-label>
        <input matInput [(ngModel)]="searchForm.name" name="name" placeholder="Search by shareholder name" appTextNormalize>
      </mat-form-field>

      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showCategory">
        <mat-label>Category</mat-label>
        <mat-select [(ngModel)]="searchForm.categoryId" name="categoryId" (selectionChange)="onCategoryChange()">
          <mat-option [value]="EMPTY_CATEGORY_ID">(Empty)</mat-option>
          <mat-option *ngFor="let category of categories$ | async" [value]="category.id">
            {{ category.name }}
          </mat-option>
        </mat-select>
        <button *ngIf="searchForm.categoryId" mat-icon-button matSuffix (click)="searchForm.categoryId = undefined; onCategoryChange(); $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showSubCategory">
        <mat-label>Sub Category</mat-label>
        <mat-select [(ngModel)]="searchForm.subCategoryId" name="subCategoryId" [disabled]="!searchForm.categoryId || searchForm.categoryId === EMPTY_CATEGORY_ID" placeholder="Sub Category">
          <mat-option [value]="EMPTY_CATEGORY_ID">(Empty)</mat-option>
          <mat-option *ngFor="let subCategory of subCategories$ | async" [value]="subCategory.id">
            {{ subCategory.name }}
          </mat-option>
        </mat-select>
        <button *ngIf="searchForm.subCategoryId" mat-icon-button matSuffix (click)="searchForm.subCategoryId = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showYear">
        <mat-label>Year</mat-label>
        <mat-select [(ngModel)]="searchForm.year" name="year" placeholder="Year">
          <mat-option *ngFor="let year of years" [value]="year">
            {{ year }}
          </mat-option>
        </mat-select>
        <button *ngIf="searchForm.year" mat-icon-button matSuffix (click)="searchForm.year = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showStartYear">
        <mat-label>Start Year</mat-label>
        <mat-select [(ngModel)]="searchForm.startYear" name="startYear" placeholder="Start Year">
          <mat-option *ngFor="let year of years" [value]="year">
            {{ year }}
          </mat-option>
        </mat-select>
        <button *ngIf="searchForm.startYear" mat-icon-button matSuffix (click)="searchForm.startYear = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showUser">
        <mat-label>User</mat-label>
        <mat-select [(ngModel)]="searchForm.createdBy" name="createdBy" placeholder="User">
          <mat-option *ngFor="let user of users$ | async" [value]="user.email">
            {{ user.fullName }}
          </mat-option>
        </mat-select>
        <button *ngIf="searchForm.createdBy" mat-icon-button matSuffix (click)="searchForm.createdBy = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="search-actions">
      <mat-checkbox [(ngModel)]="showOwnerships" name="showOwnerships" color="primary" (change)="onShowOwnershipsChange()">Show Ownerships</mat-checkbox>
      <div class="search-actions-spacer"></div>
      <button mat-flat-button color="primary" type="submit">
        <mat-icon>search</mat-icon>
        Search
      </button>
      <button mat-flat-button type="button" class="nrg-error-flat-button"  (click)="clearSearch()">
        <mat-icon>clear</mat-icon>
        Clear
      </button>
    </div>
  </form>
</div>
